import { gql } from "@apollo/client";

export const CREATE_REQUEST = gql`
	mutation CreateRequest($params: RequestMutationParams) {
		request(params: $params) {
			createRequest {
				success
				requestId
				message
			}
		}
	}
`;

export const CREATE_OFFER_REQUEST = gql`
	mutation CreateOfferRequest($params: RequestMutationParams!) {
		request(params: $params) {
			createOfferRequest {
				success
				requestId
				dialogId
				buyerUnitId
			}
		}
	}
`;
